import { changeCulture, saveQuestionCulture } from "./general";
import { requestBatches } from "./batches";
import { getCulture } from "./culture";

// "Use {New} from now on": persist the new default and show it this session.
const useLanguageFromNowOn = (newCulture) => {
    return (dispatch, getState) => {
        return dispatch(saveQuestionCulture(newCulture)).then(() => {
            if (getCulture(getState()) !== newCulture) {
                dispatch(changeCulture(newCulture));
                dispatch(requestBatches());
            }
        });
    };
};

// "Keep {Current}": persist the current language as the default (stops future asking),
// and revert the session to it if a pick had changed the session.
const keepCurrentLanguage = (currentCulture) => {
    return (dispatch, getState) => {
        return dispatch(saveQuestionCulture(currentCulture)).then(() => {
            if (getCulture(getState()) !== currentCulture) {
                dispatch(changeCulture(currentCulture));
                dispatch(requestBatches());
            }
        });
    };
};

// "Just for this visit" (and backdrop/close): session only, no persistence.
const useLanguageThisVisit = (newCulture) => {
    return (dispatch, getState) => {
        if (getCulture(getState()) !== newCulture) {
            dispatch(changeCulture(newCulture));
            dispatch(requestBatches());
        }
    };
};

export { useLanguageFromNowOn, keepCurrentLanguage, useLanguageThisVisit };
